import React from 'react';
import { classnames, use } from '../../lib';
export const Text = ({ children, className, weight = 'default', size = '0_875', color = 's100', align }) => {
    return (React.createElement("div", { className: classnames(use(className, className), use(color, `type--${color}`), use(align, `type--${align}`), use(size, `type--${size}`), use(weight, `type--${weight}`)) }, children));
};
//# sourceMappingURL=Text.js.map